import {
  takeEvery,
  put,
  call,
  select,
} from 'redux-saga/effects'
import axios from 'axios'

import {
  Types,
  fetchPageSuccess,
  fetchPageFailure,
} from '../ducks/page'

function* fetchPage({ payload }) {
  try {
    const host = yield select(state => state.settings.host)
    const response = yield call(axios, {
      method: 'GET',
      url: `${host}${payload}`,
      headers: {
        'origin-local': 'http://joaoemaria.caseme.local',
      },
    })

    yield put(fetchPageSuccess({
      ...{ body: { subtitle: '' } },
      ...response.data,
    }))
  } catch (e) {
    yield put(fetchPageFailure(e.response.status))
  }
}

export default function* () {
  yield takeEvery(Types.FETCH_PAGE, fetchPage)
}
